// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__U6Skr","plus":"styles_plus__Nvvs1","key":"styles_key__Xc_pw"};